/** Generate a card-style skeleton placeholder */
export function skeletonCard(count = 3): string {
  let html = '';
  for (let i = 0; i < count; i++) {
    html += `<div class="skeleton-card">
      <div class="skeleton skeleton-avatar"></div>
      <div class="skeleton-card-lines">
        <div class="skeleton skeleton-line" style="width:${60 + (i * 13) % 30}%"></div>
        <div class="skeleton skeleton-line" style="width:${40 + (i * 17) % 25}%"></div>
      </div>
    </div>`;
  }
  return `<div class="skeleton-container">${html}</div>`;
}

/** Generate a table-style skeleton placeholder */
export function skeletonTable(rows = 5, cols = 4): string {
  let headerHtml = '<tr>';
  for (let c = 0; c < cols; c++) {
    headerHtml += `<th><div class="skeleton skeleton-line" style="width:${50 + (c * 19) % 40}%"></div></th>`;
  }
  headerHtml += '</tr>';

  let bodyHtml = '';
  for (let r = 0; r < rows; r++) {
    bodyHtml += '<tr>';
    for (let c = 0; c < cols; c++) {
      bodyHtml += `<td><div class="skeleton skeleton-line" style="width:${45 + ((r + c) * 13) % 50}%"></div></td>`;
    }
    bodyHtml += '</tr>';
  }

  return `<div class="table-wrap"><table class="data-table"><thead>${headerHtml}</thead><tbody>${bodyHtml}</tbody></table></div>`;
}

/** Generate a stat-grid skeleton */
export function skeletonStats(count = 4): string {
  let html = '';
  for (let i = 0; i < count; i++) {
    html += `<div class="stat-card skeleton-stat">
      <div class="skeleton skeleton-circle" style="width:32px;height:32px"></div>
      <div class="skeleton skeleton-line" style="width:40%;height:24px"></div>
      <div class="skeleton skeleton-line" style="width:60%"></div>
    </div>`;
  }
  return `<div class="stat-grid">${html}</div>`;
}

/** Generate a schedule grid skeleton */
export function skeletonSchedule(): string {
  let cols = '';
  for (let i = 0; i < 7; i++) {
    cols += `<div class="schedule-day">
      <div class="schedule-day-header"><div class="skeleton skeleton-line" style="width:60%"></div></div>
      <div class="schedule-day-shifts">
        <div class="skeleton skeleton-line" style="height:24px;margin-bottom:4px"></div>
        ${i % 2 === 0 ? '<div class="skeleton skeleton-line" style="height:24px"></div>' : ''}
      </div>
    </div>`;
  }
  return `<div class="schedule-grid">${cols}</div>`;
}
